<script>

export default {
  methods: {
    simpleDateFormat(date, format = 'YYYY年MM月DD日') {
      if (date && this.$moment(date).isValid) {
        return this.$moment(date).format(format)
      } else {
        return null
      }
    }
  }
}
</script>
